import React, { useContext } from 'react';
import { QAResultContent } from '../QAResultContent/QAResultContent';
import { Pager } from '../Pager/Pager.component';
import { useSEO } from './useSEO';
import QAContext from '../../context/QAContext';
import { useQAResult } from './useQAResult';
import { dataModel } from '../dataModel';
import { QAResultHeader } from './QAResultHeader';

export const QAResultDesktop = () => {
  let {
    searchText, Results, TotalResults
  } = useContext(QAContext);

  const qaResult = useQAResult();
  const { seoResults, seoAnswers, seoTotalResults } = useSEO(qaResult);

  const showResults = !!(Results?.length || seoResults?.length || !searchText);

  const showPager = (Results?.length > 0 || qaResult);

  return (
    <>
      <QAResultHeader seoTotalResults={seoTotalResults} />
      {showResults && (
        <div>
          <QAResultContent
            seoResults={seoResults}
            seoAnswers={seoAnswers}
            seoTotalResults={seoTotalResults}
          />
          {showPager && (
            <div className="sui-w-full">
              {/* eslint-disable-next-line */}
              <div className="sui-py-6 sui-px-2.5 sui-w-fill">
                {(TotalResults || seoTotalResults) > 4 && (
                  <div className="sui-mb-4">
                    <Pager seoTotalResults={seoTotalResults} />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

QAResultDesktop.displayName = 'QAResultDesktop';

QAResultDesktop.dataModel = dataModel;